import {
  makeEverythingLowerCase,
  setAnalytics
} from '../../../thd-analytics-utils';

// BROS (SEO) page load. FED triggers bros.page-load with the page name and one of
// 'bros plp', 'bros search result' or 'bros category' as the page type.
export const BROS_DEFAULT_PAGE_TYPE = 'bros plp';

export function bros() {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('bros.page-load', ({ output = {} } = {}) => {
    const {
      pageName = '',
      pageType
    } = output || {};

    digitalData.page = {
      pageInfo: {
        pageLoadEvent: 'seo',
        pageName,
        pageType: pageType || BROS_DEFAULT_PAGE_TYPE,
        ...(digitalData?.page?.pageInfo?.adBlocker && { adBlocker: digitalData.page.pageInfo.adBlocker })
      },
      category: {
        subCategory1: pageName,
        subCategory2: pageName
      }
    };

    digitalData.page.pageInfo = makeEverythingLowerCase(digitalData?.page?.pageInfo);
    digitalData.page.category = makeEverythingLowerCase(digitalData?.page?.category);

    setAnalytics(digitalData);
  });
}
